module.exports = __webpack_public_path__ + "img/alice-beige.0216e1ce.png";